export enum ServiceCategoryFlatType {
  WHEEL_CHANGE = 0,
  WHEEL_STORAGE = 1,
  CAR_WASH = 2,
  TIRE_SALE = 3,
  RIM_SALE = 4,
  WINDSCREEN_REPAIR = 5
}
